/** Canonical, preview-enabled share links; private/off-market records keep their direct URL. */
export function getPropertyShareUrl(property, config) {
  const base = /^https?:\/\//i.test(config.BASE_URL) ? config.BASE_URL : `https://${config.BASE_URL}`;
  const origin = new URL(base).origin;
  const key = String(property.listing_key || '');
  const status = property.standard_status;
  const preview = config.LISTING_PREVIEWS_ENABLED === true
    && /^[A-Za-z0-9_-]{1,128}$/.test(key)
    && !property.isPrivate && !key.startsWith('PRIVATE_')
    && property.internet_entire_listing_display_yn !== false
    && (!status || ['Active', 'Active Under Contract', 'Pending'].includes(status));
  return `${origin}/${preview ? 'share/listing' : 'listing'}/${encodeURIComponent(key)}`;
}
